import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { GridAllModule, GridModule } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PurchaseRequestRoutingModule } from './purchase-request-routing.module';
import { PurchaseRequestComponent } from './purchase-request.component';

import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { CalendarModule } from 'angular-calendar';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { PurchaseListService } from './purchase-request-dataservice';
import { ColumnChooserService, FilterService, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';

@NgModule({
  declarations: [PurchaseRequestComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    GridModule,
    MyDatePickerModule,
    ReactiveFormsModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    CommonModule,
    CalendarModule,
    GridAllModule,
    DropDownListAllModule,
    PurchaseRequestRoutingModule,
    NgbModule,
    DropDownListModule
  ],
  exports:[PurchaseRequestComponent],
  providers:[PurchaseListService,ColumnChooserService,PageService,SortService,FilterService,ResizeService],
})

export class PurchaseRequestModule { }
